import { useEffect, useState } from "react";
import api from "../api";

// Admin-managed page content. One fetch per page+language, cached for the session.
const cache = {};

export const loadContent = (kind, lang = "en") => {
  const key = `${kind}:${lang}`;
  if (!cache[key]) {
    cache[key] = api.get(`/content/${kind}?lang=${lang}`)
      .then((r) => r.data?.data || {})
      .catch(() => ({}));
  }
  return cache[key];
};

export const useContent = (kind) => {
  const lang = (typeof localStorage !== "undefined" && localStorage.getItem("lp-lang")) || "en";
  const [data, setData] = useState(null);
  useEffect(() => { loadContent(kind, lang).then(setData); }, [kind, lang]);
  return data;
};
